import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class EventLogStateService {
  private readonly TRAIN_KEY = 'train';
 
 
  setTrainFilter(plantId: string): void {
    sessionStorage.setItem(this.TRAIN_KEY, JSON.stringify({ plantId }));
  }
 
  getTrainFilter(): any {
    const saved = sessionStorage.getItem(this.TRAIN_KEY);
    return saved ? JSON.parse(saved) : {};
  }
 
  clearTrainFilter(): void {
    sessionStorage.removeItem(this.TRAIN_KEY);
  }
}
 
 